/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-01-21",
    versionChannel: "nightly",
    buildDate: "2025-01-21T00:06:04.805Z",
    commitHash: "37876dc8f168e6042412d112b62cd274589d4396",
};
